export default __webpack_public_path__ + "static/part1_6-f2f8ecaf8fb824b5aa784cf43099f303.png";